import { Box, BoxProps } from '@chakra-ui/react';

const backgrounds = {
    Trocknung: '#F08330',
    Leckortung: '#B6C5E0',
    Vorarbeiten: '#D4C360',
    Nacharbeiten: '#545557',
    Geräteverleih: '#4A9A7F',
};

/**
 * Unbekannte Typnamen bekommen den Nacharbeiten-Ton. Ohne Fallback stand hier weiße
 * Schrift ohne Hintergrund, der Chip war auf weißem Grund unsichtbar — z. B. im
 * Service-Request-Dashboard, das auch einen unbekannten `orderType` unverändert
 * durchreicht (event-subscriber.ts).
 */
const fallbackBackground = backgrounds.Nacharbeiten;

export const ProjectType = ({ children, ...props }: BoxProps) => {
    return (
        <Box
            rounded="sm"
            width="fit-content"
            px={2}
            color="white"
            fontSize={14}
            fontWeight="semibold"
            lineHeight={5}
            {...(typeof children === 'string' && {
                bg:
                    children in backgrounds
                        ? backgrounds[children as keyof typeof backgrounds]
                        : fallbackBackground,
            })}
            {...props}
        >
            {children}
        </Box>
    );
};
